export var PrepaymentBucket;
(function (PrepaymentBucket) {
    PrepaymentBucket["USAGE"] = "USAGE";
    PrepaymentBucket["PLATFORM"] = "PLATFORM";
    PrepaymentBucket["CUSTOM"] = "CUSTOM";
    PrepaymentBucket["VARIABLE"] = "VARIABLE";
    PrepaymentBucket["PDE"] = "PDE";
    PrepaymentBucket["PROFESSIONAL"] = "PROFESSIONAL";
    PrepaymentBucket["OTHER"] = "OTHER";
})(PrepaymentBucket || (PrepaymentBucket = {}));
export var InvoiceType;
(function (InvoiceType) {
    InvoiceType["USAGE"] = "USAGE";
    InvoiceType["OTHER"] = "OTHER";
})(InvoiceType || (InvoiceType = {}));
export var PrepaymentStatus;
(function (PrepaymentStatus) {
    PrepaymentStatus["ACTIVE"] = "ACTIVE";
    PrepaymentStatus["CANCELED"] = "CANCELED";
})(PrepaymentStatus || (PrepaymentStatus = {}));
//# sourceMappingURL=constants.js.map